<template>
  <div class="gs-app gm-sequence-assignment gm-sequence-tag-assignment">
    <div class="step3 mb-6">
      <p class="font-semibold text-base text-dark mb-2">
        {{ $t('frontend_groovemail_sequences_startingrules_tags') }}
      </p>
      <div class="flex border-grey-300">
        <div class="w-full flex flex-no-wrap flex-col">
          <div class="w-full mb-2 relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangecategory($event)"
              v-model="localModel.category"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select_category') }}
              </option>
              <option
                v-for="(category, index) in categories"
                :key="index"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>
          <div class="w-full relative">
            <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
            <select
              @change="onChangetag($event)"
              v-model="localModel.tag"
              class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
            >
              <option value>
                {{ $t('frontend_groovemail_sequences_splitnode_select_tag') }}
              </option>
              <option
                v-for="(tag, index) in this.tags"
                :key="index"
                :value="tag.id"
                :data-name="tag.name"
              >
                {{ tag.name }}
              </option>
            </select>
          </div>

          <div
            class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
            @click="createNewTag"
          >
            <PlusIcon class="h-5 w-5"/>
            <p>{{ $t('frontend_groovemail_contacts_step4_create_newtag') }}</p>
          </div>

          <div class="w-full">
            <div class="text-center w-full flex flex-row flex-wrap">
              <p
                class="list-chip font-hairline leading-8 border-0 text-primary-invert bg-primary mt-2 mr-2 relative"
                v-for="(option, index) in localModel.tagassigned"
                :key="index"
              >
                <span class="text-xs font-semibold pl-2 pr-2">
                  {{ option.name }}
                </span>
                <span @click="deletetag(option)" class="px-2">
                  <span style="cursor: pointer" class="fa text-xs cross-chip fill-current"
                    >&#xf00d;</span
                  >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import Category from '@/models/Category';
import 'vue2-timepicker/dist/VueTimepicker.css';

// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';

export default {
  name: 'TagNode',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      localModel: this.model,
      currentstep: 1,
      categories: [],
      categoriesA: [{ id: 1, name: 'Sample Category' }],
      tags: [],
      nextbtndisabled: true,
      addbtndisabled: true,
      savebtndisabled: true,
      tagdisabled: true,
      tagname: '',
    };
  },

  components: {
    PlusIcon,
    DownIcon,
  },

  methods: {
    createNewTag() {
      this.$emit('createNewTag', 4);
    },

    async updateTagData(tags) {
      this.categories = await Category.$get();
      if (tags && tags.data) {
        this.localModel.tagassigned.push({
          name: tags.data.name,
          id: tags.data.id,
        });
      }
    },

    deletetag(option) {
      const index = this.localModel.tagassigned.indexOf(option);
      this.localModel.tagassigned.splice(index, 1);
    },

    onChangetag(e) {
      this.tagname =
        e.target.options[e.target.options.selectedIndex].dataset.name;

      this.localModel.tagassigned.push({
        name: this.tagname,
        id: this.localModel.tag,
      });
      this.tags = [];
      this.localModel.tag = '';
      this.localModel.category = '';
    },

    async onChangecategory(e) {
      const { data } = await axios.get('/mailtag', {
        params: { category: e.target.value },
      });
      if (data.length > 0) {
        this.tags = data;
      }
    },

    dayshandler(option) {
      if (option.value === false) {
        const index = this.localModel.tagdays.indexOf(option.title);
        if (index > -1) {
          this.localModel.tagdays.splice(index, 1);
        }
      } else {
        this.localModel.tagdays.push(option.title);
      }
    },
  },

  async created() {
    this.$wait.start('category');
    this.categories = await Category.$get();
    this.$wait.end('category');
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>

<style scoped>
.gm-sequence-assignment .step3 {
  margin-bottom: 1.5rem;
}

.gm-sequence-assignment select {
  min-height: 2.75rem;
  height: 2.75rem;
  line-height: 1.25rem;
}

.gm-sequence-assignment .text-primary.cursor-pointer {
  min-height: 2.75rem;
  align-items: center;
  color: var(--gs-primary);
}

.gm-sequence-assignment .list-chip {
  display: inline-flex;
  align-items: stretch;
  max-width: 100%;
  min-height: 2.75rem;
  margin: 0.625rem 0.5rem 0 0;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-sm);
  background: var(--gs-surface-subtle);
  color: var(--gs-foreground);
  line-height: 1.25rem;
  text-align: left;
}

.gm-sequence-assignment .list-chip > span:first-child {
  min-width: 0;
  padding: 0.625rem 0.25rem 0.625rem 0.75rem;
  overflow-wrap: anywhere;
}

.gm-sequence-assignment .list-chip > span:nth-child(2) {
  display: inline-flex;
  flex: 0 0 2.75rem;
  align-items: center;
  justify-content: center;
  min-width: 2.75rem;
  min-height: 2.75rem;
  padding: 0;
  color: var(--gs-danger);
  cursor: pointer;
}

.gm-sequence-assignment .list-chip > span:nth-child(2):focus-visible {
  outline: 2px solid var(--gs-primary);
  outline-offset: -2px;
}

@media (max-width: 40rem) {
  .gm-sequence-assignment .list-chip {
    display: flex;
    width: 100%;
    margin-right: 0;
  }
}
</style>
